"use strict";
exports.__esModule = true;
exports.ASSET_ACCOUNTS = void 0;
var ASSET_ACCOUNTS = {
    CASH_SAVINGS: 'cashSavings',
    PROPERTY: 'property',
    SHARES: 'shares',
    OTHER: 'other'
};
exports.ASSET_ACCOUNTS = ASSET_ACCOUNTS;
